import axios from 'axios'

import * as types from '../types'
import router from '../../router'
import {MUTATE_PUSH_TEXTMESSAGES} from "../types";

const state = {
  textmessages: '',
  loadingTextmessages: false
}

const getters = {
  textmessages: (state) => {
    return state.textmessages
  },
  loadingTextmessages: (state) => {
    return state.loadingTextmessages
  }
}

const mutations = {
  [types.MUTATE_LOADING_TEXTMESSAGES]: (state, status) => {
    state.loadingTextmessages = status
  },
  [types.MUTATE_PUSH_TEXTMESSAGES]: (state, textmessages) => {
    state.textmessages = textmessages
  }
}

const actions = {
  [types.FETCH_TEXTMESSAGES]: ({ commit, state, dispatch }, requestData) => {
    commit(types.MUTATE_LOADING_TEXTMESSAGES, true)
    axios
      .get('/textmessages')
      .then(res => {
        commit(types.MUTATE_PUSH_TEXTMESSAGES, res.data)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_TEXTMESSAGES, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
